import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    columnHeader: {
        color: theme.palette.primary.dark,
        "&.MuiTypography-root": {
            fontSize: "12px",
        },
    },
    waiting: {
        color: theme.palette.error.main,
        fontStyle: "italic",
        "&.MuiTypography-root": {
            fontSize: "14px",
        },
    },
    toBeDefined: {
        fontStyle: "italic",
        "&.MuiTypography-root": {
            fontSize: "14px",
        },
    },
    pendingMessage: {
        fontFamily: "Open Sans !important",
        color: theme.palette.error.main,
        fontStyle: "italic",
        fontSize: "14px !important",
    },
}));
